import React from 'react';

const EducationVerification = () => {
  return (
    <div>
      EducationVerification
      EducationVerification
    </div>
  );
}

export default EducationVerification;
